export function isTranscriptionOff(state) {
    const noLanguageLabel = 'transcribing.subtitlesOff';
    const language = state['features/subtitles']._language;
    return language === null || language === noLanguageLabel;
}
